<template>
  <div ref="layout" class="page-container">
    <div class="query-title">物流配送时效查询</div>
    <div class="content table-query">
      <collapse-query2>
        <template slot="content">
          <div class="query-container">
            <el-form inline class="form" size="mini" label-width="100px">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="启运城市">
                    <el-input v-model="conditions.shipcityname" placeholder="请输入" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="省份">
                    <el-select
                      v-model="conditions.provincecode"
                      placeholder="请选择"
                      clearable
                      @change="changeProvince"
                    >
                      <el-option
                        v-for="item in selectDataOptions['province']"
                        :key="item.BLAND"
                        :value="item.BLAND"
                        :label="item.BEZEI"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="城市">
                    <el-select
                      v-model="conditions.citycode"
                      placeholder="请选择"
                      type="select"
                      name=""
                      default-value=""
                      clearable
                      @change="changeCity"
                    >
                      <el-option
                        v-for="item in selectDataOptions['city']"
                        :key="item.CITY_CODE"
                        :value="item.CITY_CODE"
                        :label="item.CITY_NAME"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="区县">
                    <el-select v-model="conditions.countycode">
                      <el-option
                        v-for="item in selectDataOptions['county']"
                        :key="item.STRT_CODE"
                        :label="item.MC_STREET"
                        :value="item.STRT_CODE"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-button size="mini" icon="el-icon-refresh-right" @click="reset">重置</el-button>
              <el-button
                size="mini"
                icon="el-icon-search"
                type="primary"
                @click="queryData(1)"
              >查询</el-button>
            </el-form>
          </div>
        </template>
      </collapse-query2>

      <div class="table-container">
        <TableCommon
          title="明细数据"
          :pagination="pagination"
          :custome-config="() => vxeShowCustom('gridOptions')"
          @pagination-change="handleTablePaginationChange"
        >
          <template #button />
          <vxe-grid
            ref="gridOptions"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="300"
            align="center"
            size="mini"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
          >
            <template #abnoramlBillCode="{ row }">
              <el-link @click="toDetail(row)">{{ row.abnoramlBillCode }}</el-link>
            </template>
            <template #fhd="{ row }">
              <el-link>{{ row.fhd }}</el-link>
            </template>
          </vxe-grid>
        </TableCommon>
      </div>
    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      title="客户选择"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <client-select ref="dialogSelect" />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="submitHandle"
        >提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiQueryLogisticsShipLimit } from '@/api/applyForGoods/logisticsAbnormal'
const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')
import { getArea, apiGetOrgOrBase } from '@/api/sap/common-sap'

export default {
  components: { ClientSelect },
  data() {
    return {
      valDate: null,
      showDialog: false,
      currentData: {},
      conditions: {
        citycode: '',
        provincecode: '',
        shipcityname: '',
        createdDate: '',
        statrDate: '',
        endDate: ''
      },
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      selectDataOptions: {},
      provinceList: [],
      cityList: [],
      steetList: [],
      loading: false,
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 50 },
          { field: 'warehouse', title: '仓库名称 ', width: 110 },
          { field: 'shipcityname', title: '启运城市', width: 110 },
          { field: 'provincename', title: '省份名称 ', width: 110 },
          { field: 'cityname', title: '城市名称', width: 110 },
          { field: 'countyname', title: '县城名称', width: 110 },
          { field: 'stockuplimit', title: '备货时效(H)', width: 110 },
          { field: 'shiplimit', title: '运输时效(H)', width: 110 },
          { field: 'transferlimit', title: '中转时效(H)', width: 110 },
          { field: 'remark', title: '备注', width: 110 },
          //  { field: 'statusTextView', title: '状态', width: 110 },
          { field: 'createdDate', title: '创建时间', width: 110 },
          { field: 'createdByName', title: '创建人', width: 110 }
        ],
        data: []
      }
    }
  },
  computed: {},
  watch: {
    valDate(nV, oV) {
      this.conditions.endDate = nV ? nV[1] : ''
      this.conditions.startDate = nV ? nV[0] : ''
    }
  },
  created() {
    this.init()
    this.queryData()
  },

  methods: {
    init() {
      getArea().then(res => {
        this.$set(this['selectDataOptions'], 'province', res.DATA)
        this.$set(this['selectDataOptions'], 'city', [])
        // this.$set(this['selectDataOptions'], 'county', [])
      })
    },
    changeProvince(e) {
      if (!e) return
      getArea(e, 'city').then(res => {
        this.$set(this['selectDataOptions'], 'city', res.DATA)
        this.conditions.citycode = ''
        // this.conditions.countycode = ''
      })
    },
    changeCity(e) {
      if (e) {
        getArea(e, 'street').then(res => {
          this.$set(this['selectDataOptions'], 'county', res.DATA)
        })
      }
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    exportExcel() {},
    // 处理分页事件
    handleTablePaginationChange(page) {
      Object.assign(this.pagination, page)
      if (this.queryData) {
        this.queryData()
      }
    },
    async queryData(page) {
      this.loading = true
      page && (this.pagination.page = page)
      const params = { ...this.conditions, ...this.pagination }

      try {
        const {
          data: { Rows, Total }
        } = await apiQueryLogisticsShipLimit(params)
        this.gridOptions.data = Rows
        this.pagination.totalCount = Total
      } catch (e) {
        console.log(e)
      }
      this.loading = false
    },
    reset() {
      this.conditions = {
        abnoramlBillCode: '',
        expirationDate: '',
        customer: '',
        fhd: '',
        status: '',
        createdDate: '',
        statrDate: '',
        endDate: '',
        customerName: ''
      }
    },
    openDialog(e) {
      e.target.blur()
      this.showDialog = true
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()

      if (!data) return
      this.conditions.customer = data.customerCode
      this.conditions.customerName = data.customerName
      this.showDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/data-searching/logisticsDeliveryLimitQuery.vue